<template>
  <div class="chart-pje-objetivo">
    <div class="chart-pje-objetivo-outter" :key="key">
      <div :class="{ 
            'chart-pje-objetivo-inner': true,
            'amarillo': pjeActual >= 90,
            'verde': pjeActual >= 100
          }" 
          :style="{ width: pjeAvance + '%'}">
      <!-- <div :class="{ 
            'chart-pje-objetivo-inner': true,
            'amarillo': pjeActual >= 90,
            'verde': pjeActual >= 100,
            'magenta': pjeActual >= 110,
          }" 
          :style="{ width: pjeAvance + '%'}"> -->
        <span :class="{ 
          'chart-pje-objetivo-valor': true,
          'light': pjeActual > 60
        }"
        :style='"color: " + getContrastingTextColor() + ";"'>{{ pjeActual | numero(2, true) }}%</span>
      </div>
    </div>
    <p class="description">{{ descripcion }}</p>
  </div>

</template>

<script>
export default {
  props: {
    pjeActual: {
      type: Number,
      default: 0
    },
    descripcion: {
      type: String,
      default: 'Tiempo transcurrido'
    }
  },
  data() {
    return {
      key: 0,
      pjeAvance: 0,
    }
  },
  created() {
    this.pjeAvance = (parseFloat(this.pjeActual) || 0) > 100 ? 100 : (parseFloat(this.pjeActual) || 0);
  },
  methods: {
    refresh() {
      this.key++;
    },
    getContrastingTextColor() {
      let hexColor = 'E46651';

      if (this.pjeActual < 40) {
        hexColor = 'DDDDDD';
      } else if (this.pjeActual >= 90) {
        hexColor = 'FAFA05';
      } else if (this.pjeActual >= 100) {
        hexColor = '41B883';
      } else if (this.pjeActual >= 110) {
        hexColor = 'FF0187';
      }

      // // Quita el símbolo # si está
      // hexColor = hexColor.replace('#', '');

      // Parsea los valores R, G y B
      const r = parseInt(hexColor.substring(0, 2), 16);
      const g = parseInt(hexColor.substring(2, 4), 16);
      const b = parseInt(hexColor.substring(4, 6), 16);

      // Calcula la luminancia
      const luminance = 0.299 * r + 0.587 * g + 0.114 * b;

      // Retorna negro o blanco según la luminancia
      return luminance > 140 ? '#23282c' : '#FFFFFF';
    }
  }
}
</script>

<style>
  .chart-pje-objetivo {
    margin-top: 0; 
    margin-bottom: 0;
  }
  .chart-pje-objetivo-outter {
    width: 100%;
    left: 0; 
    height: 20px;
    background-color: #DDDDDD;
    border: 1px solid #ccc;
    position: relative;
    overflow: hidden;
    margin-bottom: 0;
  }
  .chart-pje-objetivo-inner {
    height: 100%;
    background-color: #E46651;
    /* background-color: #FF0187; */
    transition: width 0.3s ease;
  }
  .chart-pje-objetivo-inner.amarillo {
    background-color: #FAFA05;
  }
  .chart-pje-objetivo-inner.verde {
    background-color: #41B883;
  }
  .chart-pje-objetivo-inner.magenta {
    background-color: #FF0187;
  }


  .chart-pje-objetivo-valor {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    font-size: 0.8em;
    font-weight: 600;
    color: rgb(35, 40, 44);
    pointer-events: none;
  }
  .chart-pje-objetivo-valor.light {
    color: white;
  }
  .chart-pje-objetivo p.description {
    font-size: 0.8em;
    font-style: italic;
    margin-bottom: 0;
  }
</style>


